import { subDays } from 'date-fns';

import { _mock } from './_mock';
import { _fullNames } from './assets';
import { randomInArray } from '../utils/random';

export const FINANSIAL_DOCUMENTS_OPTIONS = [
  { value: 'Paid', label: 'Paid' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Overdue', label: 'Overdue' },
  { value: 'Draft', label: 'Draft' },
];

export const _affiliateRules = [...Array(20)].map((_, index) => ({
  id: _mock.id(index),
  rule: 'Rule Name',
  invoiceNumber: `INV-${index}`,
  merchant: 'Hilan',
  date: '03.10.2023-03.10.2024',
  valueType: '%',
  value: '3',
  status: 'active',
  assigned: 'Client, Client, Merchant',
}));

export const _historyDocumentsTable = [...Array(20)].map((_, index) => ({
  id: _mock.id(index),
  invoiceNumber: _mock.number.nativeL(index),
  merchant: randomInArray(_fullNames),
  activity: randomInArray(['Rosh Ashana', 'Yom Kef', 'New Year', 'Birthday']),
  due: subDays(new Date(), index),
  amount: randomInArray([10000, 20000, 30000, 40000]),
  revenue: randomInArray([10, 20, 30, 40, 50]),
  myPercent: randomInArray(['10%', '20%', '30%']),
}));

export const _myAgents = [...Array(20)].map((_, index) => ({
  id: _mock.id(index),
  agentsName: _mock.fullName(index),
  smbAccount: 'Hilan',
  activity: 'Rosh Hashana ',
  date: subDays(new Date(), index),
  status: 'active',
  creator: 'Jaqueline Spencer',
  revenue: randomInArray([20, 30, 40, 50, 60]),
  agentsLevel: randomInArray([1, 2, 3, 4]),
}));
